<template>
  <PageWrap page-title="Sucursales">
    <b-row>
      <b-col md="8" lg="6">
        <BfInput
          v-model="searchTerm"
          data-key="key"
          label="Búsqueda"
          placeholder="Busca por código o nombre"
          suffix-icon="el-icon-search"
          @input="searchBranches"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" lg="12">
        <LoadingIndicator
          v-if="loadingData"
        />

        <BfTable
          v-else
          :columns="tableColumns"
          :data="branches"
          border
          cell-class-name="tasaciones-small-cell"
          @row-click="tableRowClick"
          @sort-change="sortTable"
        >
          <span slot="sucursal" slot-scope="{row}" class="tasaciones-table-marker">
            {{row.sucursal}}
          </span>
        </BfTable>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'branch'}" tag="router-link">Nueva</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="branches.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          :pager-count="9"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import debounce from 'lodash.debounce';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import router from '@/router';
import { branchAPI } from '@/api';

export default {
  name: 'BranchesList',

  data() {
    return {
      branches: [],
      currentPage: 1,
      loadingData: false,
      perPage: 15,
      searchTerm: '',
      totalRows: 0,
      tableSort: '',
    };
  },

  created() {
    this.loadData();
  },

  methods: {

    sortTable(data) {
      this.tableSort = data;
      this.loadData();
    },

    async loadData() {
      this.loadingData = true;
      const { key = null, order } = this.tableSort;
      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total },
        } = await branchAPI.getAll({
          name: this.searchTerm,
          page: this.currentPage,
          perPage: this.perPage,
          sort: key ? `${order === 'descending' ? '-' : ''}${key}` : '',
        });

        this.branches = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },

    // eslint-disable-next-line func-names
    searchBranches: debounce(function() {
      this.currentPage = 1;
      this.loadData();
    }, 350),

    updatePagination(newPage) {
      this.currentPage = newPage;
      this.loadData();
    },

    tableRowClick({ row, column }) {
      if (column.property === 'sucursal') {
        const { id } = row;
        router.push({ name: 'branch', params: { id: `${id}` } });
      }
    },
  },

  computed: {
    tableColumns: () => [
      /* {
        label: 'Código',
        dataKey: 'codigo',
        width: 100,
      }, */
      {
        label: 'Sucursal',
        dataKey: 'sucursal',
        width: 200,
      },
      {
        label: 'Nombre',
        dataKey: 'nombre',
        sortable: 'custom',
        width: 500,
      },
      {
        label: 'Contacto',
        dataKey: 'contacto_persona',
        sortable: true,
        width: 200,
      },
      {
        label: 'Teléfono',
        dataKey: 'contacto_telefono',
      },
    ],
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
